
import ProductCard from 'VueComponents/shared/ProductCard.vue';
import {useStore} from "vuex";

export default {
    name: "ProductFilteringContent",
	props: {
		products: {
			type: Array,
			default: () => [],
		},
		paging: {
			type: Object,
			default: {},
		},
		fullWidth: {
			type: Boolean,
			default: false,
		},
		translations: {
			type: Object,
			default: {},
		},
	},
	components: {
		ProductCard,
	},
    setup() {
	    const store = useStore();
        return {
	        store
        }
    }
}
